// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminNavigation-adminHeaderNavMenuContainer-mTJZg {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  gap: 24px;
  grid-gap: 24px;
}

.AdminNavigation-adminHeaderNavMenuContainer-mTJZg::after,
.AdminNavigation-adminHeaderNavMenuContainer-mTJZg::before {
  display: none;
}

.AdminNavigation-adminHeaderMenuItem-rud0f,
.AdminNavigation-adminHeaderMenuItem-rud0f:hover,
.AdminNavigation-adminHeaderMenuItem-rud0f:focus,
.AdminNavigation-adminHeaderMenuItem-rud0f:active,
.AdminNavigation-adminHeaderMenuItem-rud0f:active:hover,
.AdminNavigation-adminHeaderMenuItem-rud0f:active:focus {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  padding: 0 !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
  grid-gap: 4px;
  color: var(--primary-foreground) !important;
  background-color: transparent !important;
  text-decoration: none;
  outline-color: transparent;
  -webkit-box-shadow: unset;
          box-shadow: unset;
  border: unset;
  text-align: start;
  cursor: pointer;
}

.AdminNavigation-adminHeaderMenuItemIconBox-K6RtS {
  display: inline-block;
  position: relative;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  width: 20px;
  height: 20px;
}

.AdminNavigation-adminHeaderMenuItemIcon-WVTwV {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
  -o-object-position: center;
     object-position: center;
}

@media (max-width: 767px) {
  .AdminNavigation-adminHeaderMenuItemText-F5nsl {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/AdminNavigation/AdminNavigation.css"],"names":[],"mappings":"AAAA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;;;EAME,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,+BAAwB;EAAxB,+BAAwB;EAAxB,wBAAwB;EACxB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,2CAA2C;EAC3C,wCAAwC;EACxC,qBAAqB;EACrB,0BAA0B;EAC1B,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAc;MAAd,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;EACnB,0BAAuB;KAAvB,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".adminHeaderNavMenuContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 24px;\n  grid-gap: 24px;\n}\n\n.adminHeaderNavMenuContainer::after,\n.adminHeaderNavMenuContainer::before {\n  display: none;\n}\n\n.adminHeaderMenuItem,\n.adminHeaderMenuItem:hover,\n.adminHeaderMenuItem:focus,\n.adminHeaderMenuItem:active,\n.adminHeaderMenuItem:active:hover,\n.adminHeaderMenuItem:active:focus {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center;\n  gap: 4px;\n  grid-gap: 4px;\n  color: var(--primary-foreground) !important;\n  background-color: transparent !important;\n  text-decoration: none;\n  outline-color: transparent;\n  box-shadow: unset;\n  border: unset;\n  text-align: start;\n  cursor: pointer;\n}\n\n.adminHeaderMenuItemIconBox {\n  display: inline-block;\n  position: relative;\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n}\n\n.adminHeaderMenuItemIcon {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: center;\n}\n\n@media (max-width: 767px) {\n  .adminHeaderMenuItemText {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminHeaderNavMenuContainer": `AdminNavigation-adminHeaderNavMenuContainer-mTJZg`,
	"adminHeaderMenuItem": `AdminNavigation-adminHeaderMenuItem-rud0f`,
	"adminHeaderMenuItemIconBox": `AdminNavigation-adminHeaderMenuItemIconBox-K6RtS`,
	"adminHeaderMenuItemIcon": `AdminNavigation-adminHeaderMenuItemIcon-WVTwV`,
	"adminHeaderMenuItemText": `AdminNavigation-adminHeaderMenuItemText-F5nsl`
};
module.exports = ___CSS_LOADER_EXPORT___;
